import type { FC } from 'react';

interface BlogContentProps {
  excerpt?: string;
  image?: string;
  title?: string;
  description?: string[];
}

const BlogContent: FC<BlogContentProps> = ({ excerpt, image, title, description }) => {
  return (
    <article className="prose prose-lg max-w-none [&_div:nth-child(5)]:pl-8 [&_div:nth-child(5)]:py-4 [&_div:nth-child(5)]:border-l-4 [&_div:nth-child(5)]:border-gray-200 [&_div:nth-child(5)]:font-crete-round [&_div:nth-child(5)]:italic [&_div:nth-child(5)]:font-semibold ">
      <div className="mb-8">
        <img
          src={image}
          alt={title}
          className="w-full h-auto object-cover"
        />
      </div>
      {description?.map((item) => (
        <div key={item} className="text-[#555555] leading-relaxed text-justify mb-4">
          {item}
        </div>
      ))}
    </article>
  );
};

export default BlogContent;